import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["isValid"],
  _excluded2 = ["isValid"];
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultFormAdd = {
  name: "",
  email: "",
  isValid: false
};
export default {
  name: "CarrierFormModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    id: Number | null
  },
  data: function data() {
    return {
      dialog: false,
      entity: null,
      gettingEntity: {
        isPending: false
      },
      form: _objectSpread({}, defaultFormAdd),
      addingEntity: {
        isPending: false,
        cancellationToken: null
      },
      updatingEntity: {
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAdding: function isAdding() {
      return !this.id > 0;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.addingEntity.isPending || this.updatingEntity.isPending;
    }
  },
  created: function created() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    saveAddingEntity: function saveAddingEntity() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2$addingEntity$c;
        var data, isValid, withoutValid, _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this2.addingEntity.isPending = true;
              (_this2$addingEntity$c = _this2.addingEntity.cancellationToken) === null || _this2$addingEntity$c === void 0 || _this2$addingEntity$c.cancel();
              _this2.addingEntity.cancellationToken = axios.CancelToken.source();
              data = _objectSpread({}, _this2.form);
              isValid = data.isValid, withoutValid = _objectWithoutProperties(data, _excluded);
              _this = _this2;
              _context3.next = 8;
              return request("/v1/carriers/", "post", withoutValid, true, "api", _this.addingEntity.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.addingEntity.isPending = false;
                          _this.addingEntity.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to create the carrier.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 8:
              response = _context3.sent;
              _this2.addingEntity.isPending = false;
              _this2.addingEntity.cancellationToken = null;
              _this2.$toasted.show("Carrier created.", {
                type: "success"
              });
              _this2.$emit("entityAdded", response.data.value);
              _this2.close();
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    saveUpdatingEntity: function saveUpdatingEntity() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this3$updatingEntity;
        var data, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this3.updatingEntity.isPending = true;
              (_this3$updatingEntity = _this3.updatingEntity.cancellationToken) === null || _this3$updatingEntity === void 0 || _this3$updatingEntity.cancel();
              _this3.updatingEntity.cancellationToken = axios.CancelToken.source();
              data = _objectSpread({}, _this3.form);
              isValid = data.isValid, withoutValid = _objectWithoutProperties(data, _excluded2);
              _this = _this3;
              _context5.next = 8;
              return request("/v1/carriers/".concat(_this3.id), "put", withoutValid, true, "api", _this.updatingEntity.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.updatingEntity.isPending = false;
                          _this.updatingEntity.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to update the carrier.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 8:
              _this3.updatingEntity.isPending = false;
              _this3.updatingEntity.cancellationToken = null;
              _this3.$toasted.show("Carrier updated.", {
                type: "success"
              });
              _this3.$emit("entityUpdated", _this3.id);
              _this3.close();
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getEntity: function getEntity() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this4$gettingEntity$;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this4.gettingEntity.isPending = true;
              (_this4$gettingEntity$ = _this4.gettingEntity.cancellationToken) === null || _this4$gettingEntity$ === void 0 || _this4$gettingEntity$.cancel();
              _this4.gettingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context6.next = 6;
              return request("/v1/carriers/".concat(_this4.id), "get", null, true, "api", null, _this4.gettingEntity.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingEntity.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to get region", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              response = _context6.sent;
              _this4.form = _objectSpread(_objectSpread({}, _this4.form), {}, {
                name: response.data.value.name,
                email: response.data.value.email
              });
              _this4.gettingEntity.isPending = false;
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    open: function open() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this5.resetData();
              _this5.dialog = true;
              if (!(_this5.id > 0)) {
                _context7.next = 5;
                break;
              }
              _context7.next = 5;
              return _this5.getEntity();
            case 5:
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                _this5.resolve = resolve;
                _this5.reject = reject;
              }));
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.gettingEntity = {
        isPending: false,
        cancellationToken: null
      };
      this.form = _objectSpread({}, defaultFormAdd);
    }
  }
};